import { Link, useHref, useNavigate, useLocation } from "react-router-dom";
import logo from "../../../assets/images/Logo.png";
import { FaBars } from "react-icons/fa";
import ToggleButton from "./sub_component/ToggleButton";
import { useEffect, useState } from "react";
import dashboardImg from "../../../assets/images/sundorban-tranparent.png";
import { HiDotsVertical } from "react-icons/hi";
import { toast } from "react-toastify";
import GetLocalStorageUserId from "../GetLocalStorageuserId";
import "./Navbar.css";
import LocationApp from "../Location/LocationApp";
import { localeData } from "moment/moment";
import jwtDecode from "jwt-decode";
import { FaChevronDown } from "react-icons/fa";
import UserTokenHandler from "../UserTokenHandler";
import {
  buildIdentityLoginUrl,
  redirectToIdentityLogin,
} from "../../../utils/identityLogin";
const apiAddress = process.env.REACT_APP_API_URL;

const Navbar = () => {
  const [showAside, setShowAside] = useState(false);
  const [token, setToken] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const ToggleEventHandler = (e) => {
    e.stopPropagation();
    setShowAside(e.target.checked);
  };
  const move = useNavigate();
  const handleLoginClick = () => {
    redirectToIdentityLogin(window.location.origin);
  };

  const handleBookNowClick = (e) => {
    e.preventDefault();
    localStorage.removeItem("sundorbonPricingDraft");
    window.location.href = "/bookings";
  };

  useEffect(() => {
    const retrivedToken = localStorage.getItem("sundorbonToken");
    if (retrivedToken) {
      setToken(retrivedToken);
    }
  }, []);

  const location = useLocation();

  const [decodedToken, setDecodedToken] = useState(null);

  const [userId, setUserId] = useState(null);
  UserTokenHandler();
  useEffect(() => {
    setUserId(GetLocalStorageUserId());
  }, []);

  const GetLocalStorageUserName = () => {
    const localdata = localStorage.getItem("sundorbonBookingUserDetails");
    const localStorageObj = JSON.parse(localdata);
    return localStorageObj;
  };

  useEffect(() => {
    setDecodedToken(GetLocalStorageUserName());
  }, [location.search, move]);

  // useEffect(() => {
  //   // Extract the token from the URL
  //   const queryParams = new URLSearchParams(location.search);
  //   const token = queryParams.get("token");

  //   if (token) {
  //     // Store token in localStorage
  //     localStorage.setItem("token", token);

  //     // Decode token to get user details
  //     const decoded = jwtDecode(token); // Decoding JWT token
  //     setDecodedToken(decoded);

  //     // Optionally, store decoded details in localStorage for easier access
  //     localStorage.setItem("decodedToken", JSON.stringify(decoded));
  //   }
  //   // else {
  //   //   // Handle missing token (e.g., redirect to login)
  //   //   // move("/login");
  //   //   handleLoginClick();
  //   // }
  // }, [location.search, move]);

  // Use decodedToken for rendering user-specific content

  //    window.addEventListener("click",()=>setShowAside(false))

  //   const navLinks = (
  //     <>
  //       <li className="font-semibold mr-12 hover:underline">
  //         <Link to={"/"}>Home</Link>
  //       </li>
  //       <li className="font-semibold mr-12 hover:underline">
  //         <a>News</a>
  //       </li>
  //       <li className="font-semibold mr-12 hover:underline">
  //         <a>Contact Us</a>
  //       </li>
  //       <li className="font-semibold mr-12 hover:underline">
  //         <a>Order</a>
  //       </li>
  //       <li className="font-semibold text-base hover:underline">
  //         <a>Sectors</a>
  //       </li>
  //       <li className="font-semibold text-base hover:underline">
  //         <Link to="/bookings">Bookings</Link>
  //       </li>
  //     </>
  //   );
  // const navLinksRight = (
  //   <>
  //     <li className=" mr-12 hover:underline">
  //       <Link to={""}>Sectors</Link>
  //     </li>
  //     <li className=" mr-12 hover:underline">
  //       <Link to={"/bookings"}>Booking</Link>
  //     </li>
  //     <li className=" mr-12 hover:underline">
  //       <Link to={""}>Contact Us</Link>
  //     </li>
  //   </>
  // );
  // const navLinksLeft = (
  //   <>
  //     <li className=" mr-12 hover:underline">
  //       <Link to={"/"}>Home</Link>
  //     </li>
  //     <li className=" mr-12 hover:underline">
  //       <Link to={""}>News</Link>
  //     </li>
  //     <li className=" mr-12 hover:underline">
  //       <Link to={""}>Order</Link>
  //     </li>
  //   </>
  // );
  const navLinksMobile = (
    <>
      <li className="lg:mr-3 xl:mr-4 hover:underline whitespace-nowrap">
        <Link onClick={() => setShowAside(false)} to={"/"}>
          Home
        </Link>
      </li>
      {/* <li className=' lg:mr-5 xl:mr-12 hover:underline'>
        <Link onClick={() => setShowAside(false)} to={''}>
          News
        </Link>
      </li> */}
      {/* <li className=" lg:mr-5 xl:mr-12 hover:underline">
        <Link onClick={() => setShowAside(false)} to={""}>
          Order
        </Link>
      </li>
      <li className=" lg:mr-5 xl:mr-12 hover:underline">
        <Link onClick={() => setShowAside(false)} to={""}>
          Sectors
        </Link>
      </li> */}
      <li className="lg:mr-3 xl:mr-4 hover:underline whitespace-nowrap">
        <Link
          onClick={(e) => {
            e.preventDefault();

            setShowAside(false);
            localStorage.removeItem("sundorbonPricingDraft");

            const targetUrl = userId
              ? "/bookings"
              : buildIdentityLoginUrl(window.location.origin);

            window.location.href = targetUrl;
          }}
          to="#"
        >
          Booking
        </Link>
      </li>

      <li className="lg:mr-3 xl:mr-4 hover:underline whitespace-nowrap">
        <Link onClick={() => setShowAside(false)} to={"/contact-us"}>
          Contact Us
        </Link>
      </li>
      {/* <li style={{ position: "absolute", top: 10, right: -30 }}>
        <LocationApp />
      </li> */}
      {decodedToken ? (
        <li className="lg:mr-3 xl:mr-4 hover:underline whitespace-nowrap">
          <Link onClick={() => setShowAside(false)} to={"/user-dashboard"}>
            User Dashboard
          </Link>
        </li>
      ) : null}
      <li className="lg:hidden" style={{ alignItems: "center", gap: "5px" }}>
        <LocationApp />
        {/* <button
    className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
     onClick={() => (window.location.href = "https://gotastebkid.azurewebsites.net/Admin/Index")}
    //onClick={() => move("/admin-dashboard")}
  >
    Admin
  </button> */}
      </li>
    </>
  );

  const logoutHandle = () => {
    toast.success("Logout Successfull", {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
    localStorage.removeItem("sundorbonBookingUserDetails");
    localStorage.removeItem("token");
    localStorage.removeItem("sundorbantoken");
    localStorage.removeItem("decodedToken");
    setToken(null);
    setDecodedToken(null);
    move("/");
    // handleLoginClick();
  };

  const toggleDropdown = () => {
    setShowDropdown((prev) => !prev);
  };
  const displayName =
    decodedToken?.Name?.length > 12
      ? `${decodedToken.Name.substring(0, 12)}...`
      : decodedToken?.Name;

  const url = useHref();
  const isBooking = url.includes("bookings");

  return (
    <div className="lg:w-full mx-auto z-50 navContainer text-black lg:left-0">
      {/* bg-gradient-to-r from-[#E67E22] to-[#C8102E] */}
      {/* for desktop view. */}
      <div
        className={`hidden lg:flex w-full max-w-screen-xl justify-between relative lg:h-[80px] items-center px-6 lg:left-0 mx-auto`}
      >
        <Link to="/" onClick={() => setShowAside(false)}>
          <img
            className="lg:w-[200px] xl:w-auto mix-blend-multiply"
            style={{ width: "240px", maxWidth: "100%" }}
            src={logo}
            alt="Logo"
          />
        </Link>
        <div className="flex items-center">
          <ul className="flex justify-end lg:text-sm xl:text-[16px] font-normal items-center text-black gap-2">
            {navLinksMobile}

            {/* Policy dropdown (hover) */}
            <li className="relative lg:mr-3 xl:mr-4 group">
              <div className="text-black px-3 py-2 rounded-md flex items-center gap-1 cursor-pointer hover:bg-black/5 select-none">
                Policies <FaChevronDown className="text-sm" />
              </div>

              <div className="absolute left-0 mt-2 w-64 bg-white text-black rounded shadow-lg border border-gray-200 overflow-hidden z-50 hidden group-hover:block">
                <Link
                  to="/privacy-policy"
                  className="block px-4 py-2 hover:bg-gray-100"
                >
                  Privacy Policy
                </Link>
                <Link
                  to="/terms-and-conditions"
                  className="block px-4 py-2 hover:bg-gray-100"
                >
                  Terms &amp; Conditions
                </Link>
                <Link
                  to="/refund-cancellation-policy"
                  className="block px-4 py-2 hover:bg-gray-100"
                >
                  Refund &amp; Cancellation Policy
                </Link>
              </div>
            </li>

            {/* Location (desktop) - show after Policies */}
            <li className="hidden lg:flex items-center lg:mr-3 xl:mr-4">
              <LocationApp />
            </li>

            {/* Book Now CTA */}
            <li className="lg:mr-3 xl:mr-4 whitespace-nowrap">
              <Link
                to="/bookings"
                onClick={handleBookNowClick}
                className="relative inline-flex items-center px-4 py-2 text-sm font-semibold text-white rounded-full
                  bg-gradient-to-r from-orange-500 to-red-600
                  shadow-lg shadow-orange-500/30
                  transition-all duration-300 ease-in-out
                  hover:scale-105 hover:shadow-xl hover:shadow-orange-500/40
                  active:scale-95
                  animate-pulse hover:animate-none"
              >
                Book Now
              </Link>
            </li>

            {/* {GetLocalStorageUserId() ? ( */}
            {decodedToken ? (
              <div className="relative ml-2">
                <button
                  onClick={toggleDropdown}
                  className="text-black px-3 py-2 rounded-md flex items-center gap-1 hover:bg-black/5"
                >
                  <span title={decodedToken.Username}>{displayName}</span>
                  <FaChevronDown className="text-sm" />
                </button>
                {showDropdown && (
                  <div className="absolute right-0 mt-2 w-40 bg-white text-black rounded shadow-lg z-50">
                    <button
                      onClick={logoutHandle}
                      className="block w-full px-4 py-2 text-left bg-white/10 hover:bg-gray-200"
                    >
                      Logout
                    </button>
                  </div>
                )}
              </div>
            ) : (
              <button
                onClick={handleLoginClick}
                className="relative overflow-hidden bg-orange-500 px-6 py-2 text-white font-semibold rounded-md
    transition-all duration-300 ease-in-out
    hover:bg-orange-600
    before:absolute before:top-0 before:left-[-75%] before:w-1/2 before:h-full
    before:bg-white before:opacity-20 before:transform before:rotate-12
    before:transition-all before:duration-500
    hover:before:left-[125%]"
                style={{ borderRadius: "5px" }}
              >
                Login
              </button>
            )}
          </ul>
        </div>
      </div>

      {/* for mobile view. */}
      <div className=" lg:hidden block z-50 text-black w-full relative ">
        <div className="relative z-50 flex items-center justify-between px-3 navContainer">
          <ToggleButton value={showAside} eventHandle={ToggleEventHandler} />

          {/* Book Now CTA (mobile) */}
          <Link
            to="/bookings"
            onClick={handleBookNowClick}
            className="relative inline-flex items-center shrink-0 px-3 py-1.5 text-xs font-semibold text-white rounded-full
              bg-gradient-to-r from-orange-500 to-red-600
              shadow-md shadow-orange-500/30
              transition-all duration-300 ease-in-out
              active:scale-95
              animate-pulse hover:animate-none"
          >
            Book Now
          </Link>
          {/* <img
            className="rounded-full absolute left-[44%] top-[10px] w-[65px] h-[65px]"
            src={logo}
            alt="logo"
          /> */}

          {/* {GetLocalStorageUserId() ? ( */}
          {/* {decodedToken ? (

            <button onClick={logoutHandle} className="text-black">
              Logout
            </button>
          ) : (
            // <Link className="text-black" to={"/login"}>
            //   Login
            // </Link>
            <button
              onClick={handleLoginClick}
              className="text-black"
              style={{ borderRadius: "5px" }}
            >
              Login
            </button>
          )} */}

          {decodedToken ? (
            <div className="relative z-50">
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  toggleDropdown();
                }}
                className="text-black px-3 flex items-center"
              >
                <span title={decodedToken.Username}>{displayName}</span>
                <FaChevronDown className="text-sm" />
              </button>

              {showDropdown && (
                <div
                  onClick={(e) => e.stopPropagation()}
                  className="absolute right-0 -mt-1 w-40  text-black rounded shadow-lg z-50"
                >
                  <button
                    onClick={logoutHandle}
                    className="block w-full px-4  text-left"
                  >
                    Logout
                  </button>
                </div>
              )}
            </div>
          ) : (
            <button
              onClick={handleLoginClick}
              className=" relative overflow-hidden bg-orange-500 px-5 py-3 text-white font-semibold ml-5
    transition-all duration-300 ease-in-out
    hover:bg-orange-600
    before:absolute before:top-0 before:left-[-75%] before:w-1/2 before:h-full
    before:bg-white before:opacity-20 before:transform before:rotate-12
    before:transition-all before:duration-500
    hover:before:left-[125%]"
            >
              Login
            </button>
          )}

          {/* <button className="">
            <Link to={"/login"}>Login</Link>
          </button> */}
        </div>

        <div
          className={`w-full text-black bg-[#fff6f1] absolute z-40 duration-300 ${
            showAside ? "translate-y-0" : "-translate-y-96"
          }`}
        >
          <ul className="flex flex-col pb-4 justify-center text-[20px] font-normal items-start pl-[40px]">
            {navLinksMobile}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
